import React, { useState, useEffect } from "react";
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import { Grid } from '@material-ui/core';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const AddCategory = (props) => {
    const [ProductName, setProductName] = useState(props.ProductName);
    const [CategoryName1, setCategoryName1] = useState('');
    const [CategoryName2, setCategoryName2] = useState('');
    const [CategoryName3, setCategoryName3] = useState('');
    const [CategoryName4, setCategoryName4] = useState('');
    const [disabledCat1, setdisabledCat1] = useState(false);
    const [disabledCat2, setdisabledCat2] = useState(false);
    const [disabledCat3, setdisabledCat3] = useState(false);
    const [Category1ID, setCategory1ID] = useState('');
    const [Category2ID, setCategory2ID] = useState('');
    const [Category3ID, setCategory3ID] = useState('');
    const [response, fetchData] = UseFetchData();
    const [responseDelete, fetchDeleteData] = UseFetchData();

    const validationSchema = Yup.object({
        ProductName: Yup.string().required('Required!'),
        CategoryName1: Yup.string().required('Required!'),
    });

    const onSubmit = values => {
        //console.log(values);
        var bodyFormData = new FormData();
        if (props.Mode === "Insert") {
            if (props.CatName === "1") {
                bodyFormData.append("ProductCat1ID", '');
                bodyFormData.append("ProdCat1Name", values.CategoryName1);
            }
            else if (props.CatName === "2") {
                bodyFormData.append("ProductCat1ID", props.CatID);
                bodyFormData.append("ProductCat2ID", '');
                bodyFormData.append("ProdCat2Name", values.CategoryName2);
            }
            else if (props.CatName === "3") {
                bodyFormData.append("ProductCat1ID", Category1ID);
                bodyFormData.append("ProductCat2ID", props.CatID);
                bodyFormData.append("ProductCat3ID", '');
                bodyFormData.append("ProdCat3Name", values.CategoryName3);
            }
            else if (props.CatName === "4") {
                // debugger;
                bodyFormData.append("ProductCat1ID", Category1ID);
                bodyFormData.append("ProductCat2ID", Category2ID);
                bodyFormData.append("ProductCat3ID", props.CatID);
                bodyFormData.append("ProductCat4ID", '');
                bodyFormData.append("ProdCat4Name", values.CategoryName4);
            }
        }
        else if (props.Mode === "Update") {
            if (props.CatName === "1") {
                bodyFormData.append("ProductCat1ID", props.CatID);
                bodyFormData.append("ProdCat1Name", values.CategoryName1);
            }
            else if (props.CatName === "2") {
                bodyFormData.append("ProductCat1ID", Category1ID);
                bodyFormData.append("ProductCat2ID", props.CatID);
                bodyFormData.append("ProdCat2Name", values.CategoryName2);
            }
            else if (props.CatName === "3") {
                bodyFormData.append("ProductCat1ID", Category1ID);
                bodyFormData.append("ProductCat2ID", Category2ID);
                bodyFormData.append("ProductCat3ID", props.CatID);
                bodyFormData.append("ProdCat3Name", values.CategoryName3);
            }
            else if (props.CatName === "4") {
                bodyFormData.append("ProductCat1ID", Category1ID);
                bodyFormData.append("ProductCat2ID", Category2ID);
                bodyFormData.append("ProductCat3ID", Category3ID);
                bodyFormData.append("ProductCat4ID", props.CatID);
                bodyFormData.append("ProdCat3Name", values.CategoryName3);
            }
        }
        bodyFormData.append("ProductID", props.ProductID);
        fetchData("Product/SaveProdCat" + props.CatName, bodyFormData);
    };

    const DeleteCategory = () => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("PKID", props.CatID);
        bodyFormData.append("CategoryType", 'Category' + props.CatName);
        fetchDeleteData("Product/DeleteProdCat", bodyFormData);
    }

    const returnData = () => {
        if (props.CatName === "2") {
            setdisabledCat1(true);
            return (
                <div>
                    <BiztranControlsFormik
                        control='input'
                        type='text'
                        label={'Category 2 Name'}
                        name='CategoryName2'
                        disabled={disabledCat2}
                        onChange={(e) => setCategoryName2(e.target.value)}
                    />
                </div>
            )
        }
        else if (props.CatName === "3") {
            setdisabledCat1(true);
            setdisabledCat2(true);
            return (
                <div>
                    <BiztranControlsFormik
                        control='input'
                        type='text'
                        label={'Category 2 Name'}
                        name='CategoryName2'
                        disabled={disabledCat2}
                        onChange={(e) => setCategoryName2(e.target.value)}
                    />
                    <BiztranControlsFormik
                        control='input'
                        type='text'
                        label={'Category 3 Name'}
                        name='CategoryName3'
                        onChange={(e) => setCategoryName3(e.target.value)}
                    />
                </div>
            )
        }
        else if (props.CatName === "4") {
            setdisabledCat1(true);
            setdisabledCat2(true);
            setdisabledCat3(true);
            return (
                <div>
                    <BiztranControlsFormik
                        control='input'
                        type='text'
                        label={'Category 2 Name'}
                        name='CategoryName2'
                        disabled={disabledCat2}
                        onChange={(e) => setCategoryName2(e.target.value)}
                    />
                    <BiztranControlsFormik
                        control='input'
                        type='text'
                        label={'Category 3 Name'}
                        name='CategoryName3'
                        disabled={disabledCat3}
                        onChange={(e) => setCategoryName3(e.target.value)}
                    />
                    <BiztranControlsFormik
                        control='input'
                        type='text'
                        label={'Category 4 Name'}
                        name='CategoryName4'
                        onChange={(e) => setCategoryName4(e.target.value)}
                    />
                </div>
            )
        }
    };

    useEffect(() => {
        if (props.CatData !== undefined) {
            props.CatData.map((ans, i) => {
                if (props.CatID === ans.ProductCat1ID) {
                    setCategoryName1(ans.ProductCat1);
                    setCategory1ID(ans.ProductCat1ID);
                    //setCategoryName2(ans.ProductCat2);
                    //setCategoryName3(ans.ProductCat3);
                }
                else if (props.CatID === ans.ProductCat2ID) {
                    setCategoryName1(ans.ProductCat1);
                    setCategoryName2(ans.ProductCat2);
                    setCategory1ID(ans.ProductCat1ID);
                    setCategory2ID(ans.ProductCat2ID);
                }
                else if (props.CatID === ans.ProductCat3ID) {
                    setCategoryName1(ans.ProductCat1);
                    setCategoryName2(ans.ProductCat2);
                    setCategoryName3(ans.ProductCat3);
                    setCategory1ID(ans.ProductCat1ID);
                    setCategory2ID(ans.ProductCat2ID);
                    setCategory3ID(ans.ProductCat3ID);
                }
                else if (props.CatID === ans.ProductCat4ID) {
                    setCategoryName1(ans.ProductCat1);
                    setCategoryName2(ans.ProductCat2);
                    setCategoryName3(ans.ProductCat3);
                    setCategoryName4(ans.ProductCat4);
                    setCategory1ID(ans.ProductCat1ID);
                    setCategory2ID(ans.ProductCat2ID);
                    setCategory3ID(ans.ProductCat3ID);
                }
            })
        }
    }, []);

    useEffect(() => {
        // debugger;
        if (response.Response === true) {
            props.getProductViewData(props.ProductID);
            props.setOpen(false);
        }
        else if (response.Response === false) {
            alert('Failed.')
        }
    }, [response]);

    useEffect(() => {
        // debugger;
        if (responseDelete.Response === true) {
            props.getProductViewData(props.ProductID);
            props.setOpen(false);
        }
        else if (responseDelete.Response === false) {
            alert('Failed.')
        }
    }, [responseDelete]);

    return (
        <div>
            <Formik initialValues={{ ProductName: ProductName, CategoryName1: CategoryName1, CategoryName2: CategoryName2, CategoryName3: CategoryName3, CategoryName4: CategoryName4 }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <BiztranControlsFormik
                            control='input'
                            type='text'
                            label='Product Name'
                            name='ProductName'
                            disabled={true}
                            onChange={(e) => setProductName(e.target.value)}
                        />
                        <BiztranControlsFormik
                            control='input'
                            type='text'
                            label={'Category 1 Name'}
                            name='CategoryName1'
                            disabled={disabledCat1}
                            onChange={(e) => setCategoryName1(e.target.value)}
                        />
                        {returnData()}
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="DELETE"
                                            onClick={DeleteCategory}
                                            startIcon={<DeleteIcon />}
                                            style={{ backgroundColor: 'red', display: props.DeleteDisplay }}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default AddCategory;
